export enum IntegrationTestStatus {
    succeded = 1,
    failed = 2,
    running = 3,
    expired = 4
}